import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

class CountryService {
	Get = async (textFilter) => {
        const queryString = utils.GetQueryStringsFromObject({textFilter})
        return await HttpClient.Get(`/api/countries?${queryString}`);
    }

    GetJurisdictions = async () =>
        await HttpClient.Get(`/api/countries/jurisdictions`);
}

export default new CountryService();